import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListActionsCell } from './emsp-bo-invoice-list-actions.cell';
import { EmspBoInvoiceListActionsHeader } from './emsp-bo-invoice-list-actions.header';

export const EmspBoInvoiceListActionsColumn: DisplayColumnDef<
  EmspUserInvoiceBaseModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: EmspBoInvoiceListActionsHeader,
  cell: EmspBoInvoiceListActionsCell,
};
